/* eslint-disable @typescript-eslint/no-explicit-any */
import { WfSalesOfficeSummaryResponse } from '../../models/WfSummary';

export const calculateTotalSalesSummary = (
  data: WfSalesOfficeSummaryResponse[],
  nameOverride: string
): WfSalesOfficeSummaryResponse => {
  const totals = data.reduce(
    (acc, curr) => {
      const num = (val: any) => (typeof val === 'number' ? val : 0);

      return {
        products: num(acc.products) + num(curr.products),
        confinement: {
          incidentItems: num(acc.confinement?.incidentItems) + num(curr.confinement?.incidentItems),
          completedItems:
            num(acc.confinement?.completedItems) + num(curr.confinement?.completedItems),
        },
        currentSituation: {
          oncallReport:
            num(acc.currentSituation?.oncallReport) + num(curr.currentSituation?.oncallReport),
          onCall: num(acc.currentSituation?.onCall) + num(curr.currentSituation?.onCall),
          outage: num(acc.currentSituation?.outage) + num(curr.currentSituation?.outage),
          otherAlerts:
            num(acc.currentSituation?.otherAlerts) + num(curr.currentSituation?.otherAlerts),
          parts: num(acc.currentSituation?.parts) + num(curr.currentSituation?.parts),
          flood: num(acc.currentSituation?.flood) + num(curr.currentSituation?.flood),
          inaccessible:
            num(acc.currentSituation?.inaccessible) + num(curr.currentSituation?.inaccessible),
          restored: num(acc.currentSituation?.restored) + num(curr.currentSituation?.restored),
        },
      };
    },
    { confinement: {}, currentSituation: {} } as any
  );

  totals.confinement.completedRate =
    totals.confinement.incidentItems > 0
      ? (totals.confinement.completedItems / totals.confinement.incidentItems).toString()
      : '0';

  totals.salesOfficeName = nameOverride || 'Total';
  totals.sectionCode = '';
  totals.sectionName = '';

  return totals as WfSalesOfficeSummaryResponse;
};
